


























































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { getFeedbackUrl, getAgencyUrl } from "@/utils/getHost";
@Component
export default class extends Vue {
  @Prop() private topClassName: any = "";
  private sdelay: any = 0;
  private feedbackUrl: string = getFeedbackUrl();
  private agencyUrl: string = getAgencyUrl();
  private handleToOnline() {
    window.open(
      "https://affim.baidu.com/cps/chat?siteId=18784727&userId=34249595&siteToken=1609f3fbd3223bb649632b9565eebc23",
      "_blank"
    );
  }
  private backTop() {
    const htmlDom: any = this.topClassName
      ? this.topClassName
      : document.getElementsByTagName("html")[0];
    if (htmlDom) {
      htmlDom.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    }
  }
}
